/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EmployeePersonalityLocalization } from './EmployeePersonalityLocalization';
/**
 * Interface representing Vapi transcriber configuration
 */
export type VapiTranscriberConfig = {
    provider?: VapiTranscriberConfig.provider;
    model?: VapiTranscriberConfig.model;
    localization?: EmployeePersonalityLocalization;
    confidenceThreshold?: number;
    keywords?: Array<string>;
};
export namespace VapiTranscriberConfig {
    export enum provider {
        DEEPGRAM = 'deepgram',
    }
    export enum model {
        NOVA_2 = 'nova-2',
    }
}

